import { css } from '@microsoft/fast-element';
export const listStyles = css `
  :host {
    contain: content;
  }

  :host,
  fast-router {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .container {
    display: flex;
    flex-direction: column;
    height: inherit;
    width: 100%;
  }
`;
